/**
 * CTA Button Group for the BuyStack23 component
 */
export default class CtaButtonGroup23 extends HTMLElement {
  private _loading = false

  constructor() {
    super()
  }

  public get loading() {
    return this._loading
  }

  public set loading(value: boolean) {
    this._loading = value
    this.render()
  }

  public connectedCallback() {
    this.setupListeners()
  }

  private setupListeners() {
    this.onclick = e => this.handleClick(e)
  }

  private handleClick({ target: t }: MouseEvent): void {
    if (t instanceof Element && t.matches('[data-action="checkout"], [data-action="checkout"] *')) {
      this.handleCheckout()
    }
  }

  private handleCheckout() {
    this.dispatchEvent(new CustomEvent('checkout', { bubbles: true }))
  }

  render(): void {
    const ctaLabel = this.querySelector('.cta-label')
    const loadingIndicator = this.querySelector('.loading-indicator')
    ctaLabel?.classList.toggle('opacity-0', this.loading)
    loadingIndicator?.classList.toggle('opacity-0', !this.loading)
  }
}
